module.exports = __webpack_public_path__ + "fonts/fa-brands-400.c5e0f14f.woff";